import type { PartnerConfig } from "@/content/partners/types"

export const STUDIO_ESMALTERIA_DELICADA_PARTNER_SLUG = "studio-esmalteria-delicada"

/** Código opaco do único agente no dia 1 (o próprio dono). */
export const STUDIO_ESMALTERIA_DELICADA_AGENT_CODE = "APMF4K7Q"

/**
 * Parceiro comercial sem LP.
 * O link é /cadastro?partner=studio-esmalteria-delicada&agente=APMF4K7Q.
 * O login continua o PF do Allan.
 */
export const studioEsmalteriaDelicadaPartnerConfig: PartnerConfig = {
  slug: STUDIO_ESMALTERIA_DELICADA_PARTNER_SLUG,
  name: "Studio e Esmalteria Delicada",
  fullName: "Studio e Esmalteria Delicada",
  logoPath: "/brand/logo-astra-energia.svg",
  benefitMode: "none",
  isActive: true,
  metadata: {
    kind: "commercial_partner",
    publicLanding: false,
  },
}
